import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import logoImage from '../ux/catlogo4.png';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Można tu podpiąć Sentry lub inny monitoring błędów w przyszłości
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#FAFAFA',
            textAlign: 'center',
            px: 3,
          }}
        >
          <Box
            component="img"
            src={logoImage}
            alt="dobrynajemca.pl"
            sx={{ height: 60, mb: 4, opacity: 0.9 }}
          />

          <WarningAmberIcon sx={{ fontSize: 64, color: '#D2691E', mb: 2 }} />

          <Typography variant="h5" sx={{ fontWeight: 700, color: '#333', mb: 1 }}>
            Coś poszło nie tak
          </Typography>

          <Typography variant="body1" sx={{ color: '#888', mb: 4, maxWidth: 400 }}>
            Wystąpił nieoczekiwany błąd. Odśwież stronę — jeśli problem się powtarza, spróbuj ponownie za chwilę.
          </Typography>

          <Button
            variant="contained"
            onClick={() => window.location.reload()}
            sx={{
              backgroundColor: '#D2691E',
              '&:hover': { backgroundColor: '#B85C00' },
              textTransform: 'none',
              borderRadius: 2,
              px: 4,
              py: 1.5,
              fontSize: '1rem',
              fontWeight: 600,
            }}
          >
            Odśwież stronę
          </Button>

          <Typography variant="caption" sx={{ color: '#bbb', mt: 6 }}>
            © {new Date().getFullYear()} dobrynajemca.pl
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
